import { Table } from '@/components/product_category/table'
import { ProductCategoryProduct } from '@/types'
interface Props {
  id: string
}

export const EditCategories = ({ id }: Props) => {
  return (
    <Table filters={ { productIdEq: id, productTypeEq: ProductCategoryProduct.Package } } deleteable />
  )
}
